
import React from 'react';

export const ReportLoading: React.FC = () => {
  return (
    <div className="flex justify-center py-8">
      <div className="animate-pulse text-gray-500">กำลังโหลดข้อมูล...</div>
    </div>
  );
};
